import { OAUTH_CLIENTS_PAGE_SIZE } from 'src/sections/workspace/sections/settings/components/oauth/constants';

export const WORKSPACE_LIST_PAGE_SIZE = 25;
const DORMANT_WORKSPACES_URL = '/!api/internal/workspaces/dormant';

const urls = {
  ui: {
    workspace: (slug: string) => `/${slug}`,
    settings: (slug: string) => `${urls.ui.workspace(slug)}/workspace/settings`,
    planUsersLink: (owner: string) => `/${owner}/workspace/settings/plan-users`,
    groupSettings: (slug: string) => `${urls.ui.settings(slug)}/groups`,
    workspaceOverview: (workspaceSlug: string) =>
      `/${workspaceSlug}/workspace/overview`,
    manageWorkspace: (workspaceSlug: string) =>
      `/${workspaceSlug}/workspace/settings`,
    containerSettings: (workspaceSlug: string) =>
      `/${workspaceSlug}/workspace/settings/packages/containers`,
    leaveWorkspace: (workspaceSlug: string) =>
      `/${workspaceSlug}/workspace/leave-workspace`,
    deactivatedWorkspaces: () => '/account/workspaces/deactivated',
    reactivateWorkspace: (workspaceSlug: string) =>
      `/workspaces/${workspaceSlug}/reactivate`,
  },
  api: {
    internal: {
      invitationRestrictions: (slug: string) =>
        `/!api/internal/workspaces/${slug}/invitation-restrictions/`,
      accessTokens: (slug: string): string =>
        `/!api/internal/workspaces/${slug}/access-tokens`,
      accessTokensPolicy: (slug: string): string =>
        `/!api/internal/workspaces/${slug}/access-tokens-policy`,
      userWorkspaces: (page?: number) => {
        if (page) {
          return `/!api/internal/workspaces/user-list/?page=${page}&pagelen=${WORKSPACE_LIST_PAGE_SIZE}`;
        } else {
          return `/!api/internal/workspaces/user-list/?pagelen=${WORKSPACE_LIST_PAGE_SIZE}`;
        }
      },
      dormantWorkspaces: (
        page?: number,
        pagelen: number = WORKSPACE_LIST_PAGE_SIZE
      ) => {
        if (page) {
          return `${DORMANT_WORKSPACES_URL}?page=${page}&pagelen=${pagelen}`;
        } else {
          // non-ideal way of getting a single dormant workspace by slug
          // used only in dormant-workspace-part-of-ws-cleanup-resource.ts
          return DORMANT_WORKSPACES_URL;
        }
      },
      removeDormant: (slug: string): string =>
        `/!api/internal/workspaces/${slug}/remove-dormant`,
      oauthClients: (workspaceSlug: string, page?: string) => {
        const baseUrl = `/!api/internal/workspaces/${workspaceSlug}/oauth/clients`;
        return page
          ? `${baseUrl}?page=${page}&pagelen=${OAUTH_CLIENTS_PAGE_SIZE}`
          : baseUrl;
      },
      oauthClient: (workspaceSlug: string, clientId: string) =>
        `/!api/internal/workspaces/${workspaceSlug}/oauth/clients/${clientId}`,
    },
    v20: {
      userWorkspaces: (page?: number) => {
        if (page) {
          return `/!api/2.0/user/workspaces?page=${page}&pagelen=${WORKSPACE_LIST_PAGE_SIZE}`;
        } else {
          return `/!api/2.0/user/workspaces?pagelen=${WORKSPACE_LIST_PAGE_SIZE}`;
        }
      },
    },
  },
  external: {
    learnMoreAboutGroupsLink:
      'https://support.atlassian.com/bitbucket-cloud/docs/organize-workspace-members-into-groups/',
    useOAuthOnBitbucketCloud:
      'https://developer.atlassian.com/cloud/bitbucket/rest/intro/#oauth-2-0',
    learnMoreAboutOAuthScopes: `https://developer.atlassian.com/cloud/bitbucket/rest/intro/#bitbucket-oauth-2-0-scopes`,
  },
};

// eslint-disable-next-line import/no-default-export
export default urls;
